import { action } from 'mobx';
import { request } from 'utils/api';

import BaseStore from './BaseStore';

export default class ParkingRulesStore extends BaseStore {
  @action
  fetchConfig(date, statusKey = 'config') {
    const status = this.createStatus(statusKey);
    return request({
      method: 'GET',
      path: `/1/parking-rules/config?date=${date}`,
    })
      .then(({ data }) => {
        const venue = data.venue ? { ...data.venue, id: data.venue._id } : null;

        status.success();
        return { ...data, venue };
      })
      .catch((err) => {
        status.error(err);
        throw err;
      });
  }
}
